import { useEffect, useState, useContext } from "react";
import { Input } from "design-react-kit";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import Repo from "../../Utility/Repo";
import ModalComponent from "../../Components/ModalComponent";
import { Link, useLocation } from "react-router-dom";
import Loader from "../../Components/Loader";
import { TokenContext } from "../../Components/TokenContext";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

function EditService(props) {
  const apiToken = useContext(TokenContext);
  const [validation, setValidation] = useState(false);
  const [isOpen, toggleModal] = useState(false);
  const [dataTemp, setDataTemp] = useState();
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState({});
  const [announcementsList, setAnnouncementsList] = useState();
  const [serviceId, setServiceId] = useState();
  const [serviceName, setServiceName] = useState();
  const [isDisabled, setIsDisabled] = useState(true);

  let query = useQuery();

  useEffect(() => {
    setLoading(false);
    if (query.get("id")) {
      Repo.getOneServices(apiToken, query.get("id"))
        .then((response) => {
          setData(response.data);
          setServiceId(response.data.id);
          setServiceName(response.data.name);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });

      Repo.getAnnouncementsByServiceOperator(apiToken, query.get("id"))
        .then((response) => {
          setAnnouncementsList(response.data);
          setLoading(true);
        })
        .catch((error) => {
          console.log(error);
          setLoading(true);
        });
    }
  }, []);

  const sendService = () => {
    setValidation(true);

    let passedValidation = true;

    if (!data.name) passedValidation = false;
    if (!data.description) passedValidation = false;
    if (!data.code) passedValidation = false;

    if (passedValidation) {
      var dataJson = JSON.stringify(data);
      setDataTemp(dataJson);
      if (apiToken) {
        toggleModal(!isOpen);
      }
    }
  };

  const sendServiceApi = async () => {
    Repo.postUpdateService(apiToken, dataTemp)

      .then((response) => {
        if (response.status == 200) {
          window.location.href = props.subfolder + "/servizi";
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const sessions = () => {
    return (
      <>
        <div className="row">
          <div className="col-lg-10">
            <h5>Bandi associati al servizio <b>{data.name || ""}</b></h5>
          </div>
          <div className="col-lg-2 text-right">
            <Link
  to={
    "/servizi/visualizza_servizio/nuova_sessione?id=" +
    serviceId +
    "&name=" +
    serviceName
  }
  className="btn btn-outline-primary float-right p-2 text-decoration-none d-inline-flex align-items-center"
>
  <svg className="icon icon-primary mr-1">
    <use href={`${iconSprite}#it-plus-circle`} />
  </svg>
  <span className="align-middle">Nuovo bando</span>
</Link>

          </div>
        </div>

        {announcementsList && announcementsList.length > 0 ? (
          <table className="table table-hover">
            <thead>
              <tr>
                <th scope="col">Titolo</th>
                <th scope="col"></th>
                <th scope="col"></th>
              </tr>
            </thead>
            <tbody>
              {announcementsList &&
                announcementsList.length > 0 &&
                announcementsList.map((x, index) => (
                  <tr key={index}>
                    <th scope="row">{x.name}</th>
                    <td></td>
                    <td className="text-right">
                      <Link
                      to={`/servizi/visualizza_servizio/dettaglio_sessione?id=${x.id}`}
                      className="btn btn-outline-primary p-1 d-inline-flex align-items-center"
                      title="Dettaglio"
                    >
                      <svg className="icon icon-primary p-1">
                        <use href={`${iconSprite}#it-search`} />
                      </svg>
                    </Link>

                      <button
                        className="btn btn-outline-danger p-1 ml-1"
                        type="button"
                        onClick={() => {
                          toggleModal(!isOpen);
                        }}
                      >
                        <svg className="icon icon-danger">
                          <use href={`${iconSprite}#it-delete`} />
                        </svg>
                      </button>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        ) : (
          <div>Non sono presenti sessioni</div>
        )}
      </>
    );
  };

  return (
    <div>
   
      <h1>Servizio {data.name || ""}</h1>
        <div className="clearfix col-lg-8 py-lg-2">
          <p>In questa sezione è possibile modificare il servizio e aggiungere un nuovo bando associato al servizio.</p>
          </div>



            
            <div className="row">


              <div className="col-lg-8">
                <Input
                  id="name"
                  disabled={isDisabled}
                  type="text"
                  placeholder="Nome Servizio*"
                  name="Nome Servizio*"
                  value={data.name || ""}
                  onChange={(e) => setData({ ...data, name: e.target.value })}
                  {...(validation &&
                    !data.name && {
                      infoText: "Il campo non può essere vuoto!",
                      className: "text-danger error_div",
                    })}
                />
              </div>

              <div className="col-lg-4">
                <Input
                  id="code"
                  disabled={isDisabled}
                  type="text"
                  placeholder="Codice MyPay*"
                  name="Codice MyPay*"
                  value={data.code || ""}
                  onChange={(e) => setData({ ...data, code: e.target.value })}
                  {...(validation &&
                    !data.code && {
                      infoText: "Il campo non può essere vuoto!",
                      className: "text-danger error_div",
                    })}
                />
              </div>

              <div className="col-lg-12">
                <textarea
                  label="Descrizione"
                  disabled={isDisabled}
                  id="description"
                  name="description"
                  rows="3"
                  value={data.description || ""}
                  onChange={(e) =>
                    setData({ ...data, description: e.target.value })
                  }
                  {...(validation &&
                    !data.description && {
                      infoText: "Il campo non può essere vuoto!",
                      className: "text-danger error_div",
                    })}
                  // disabled={editForce}
                />
              </div>

            </div> {/* fine row*/}
            {isDisabled ? (
              <div className="row my-2">
                <div className="col-lg-12 text-right">
                  <button
                    type="button"
                    className="btn btn-outline-primary"
                    data-toggle="tooltip"
                    data-placement="top"
                    onClick={() => setIsDisabled(!isDisabled)}
                    title="Modifica"
                  >
                    Modifica
                  </button>
                </div>
              </div>
            ) : (
              <div className="row my-2">
                <div className="col-lg-10 text-right">
                  <button
                    type="button"
                    className="btn btn-info text-white"
                    data-toggle="tooltip"
                    data-placement="top"
                    onClick={() => setIsDisabled(!isDisabled)}
                    title="Indietro"
                  >
                    Indietro
                  </button>
                </div>
                <div className="col-lg-2 text-right">
                  <button
                    type="button"
                    className="btn btn-primary"
                    data-toggle="tooltip"
                    data-placement="top"
                    onClick={() => sendService()}
                    title="Conferma"
                  >
                    Conferma
                  </button>
                </div>
              </div>
            )}


  

  
          <div className="shadow-sm p-3 mb-5 bg-white rounded  mt-5">{sessions()}</div>
        

      <ModalComponent
        toggleModal={toggleModal}
        isOpen={isOpen}
        header="Modifica servizio"
        body="Confermi di voler modificare il servizio?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendServiceApi()}
      ></ModalComponent>

      {!loading && <Loader></Loader>}
    </div>
  );
}

export default EditService;
